import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo, breadcrumbJsonLd } from "../components/Seo";
import { ServiceIcon } from "../components/ServiceIcon";
import { CallCta } from "../components/CallCta";
import { Testimonials } from "../components/Testimonials";
import { SERVICES } from "../data/site";

export default function ServicesIndex() {
  return (
    <div data-testid="services-index-page">
      <Seo
        title="Security Services Manitoba | Guards, Patrols & Fire Watch"
        description="Explore 1st Nations Security's full range of security services in Manitoba: uniformed guards, mobile patrol, construction site, event, fire watch & more."
        path="/security-services/"
        jsonLd={[breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Security Services", path: "/security-services" }])]}
      />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-500 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#FF9100]" data-testid="breadcrumb-home">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-300">Security Services</span>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">
            Security Guard Services in <span className="text-[#FF9100]">Manitoba</span>
          </h1>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mb-6">
            1st Nations Security delivers the full spectrum of professional security services across Manitoba — from uniformed security guards and mobile patrol security to construction site security, event security, fire watch services, and alarm response. Every service is available in Winnipeg, Brandon, Steinbach, Thompson, and communities province-wide.
          </p>
          <p className="text-gray-400 leading-relaxed max-w-3xl mb-12">
            As an Indigenous-owned security company, we build each program around your site, your risks, and your budget. Select a service below to see what's included, how we deliver it, and the Manitoba communities we cover.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <Link
                key={s.slug}
                to={`/security-services/${s.slug}`}
                data-testid={`services-card-${s.slug}`}
                className="group bg-[#14161C] hover:bg-[#1C1F28] border border-white/8 hover:border-[#FF9100]/40 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] group-hover:scale-110 transition-transform duration-300">
                    <ServiceIcon name={s.icon} />
                  </div>
                  <span className="text-xs uppercase tracking-widest text-gray-500">{s.category}</span>
                </div>
                <h2 className="font-heading text-lg font-semibold text-white mb-2 group-hover:text-[#FF9100] transition-colors">{s.title}</h2>
                <p className="text-sm text-gray-400 leading-relaxed mb-4">{s.shortDesc}</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-[#FF9100]">
                  Service details <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Testimonials />
      <CallCta heading="Not Sure Which Security Service You Need?" sub="Call our 24/7 dispatch and we'll recommend the right coverage for your Manitoba site." testid="services-cta" />
    </div>
  );
}
